import { render, staticRenderFns } from "./MinhasApolices.vue?vue&type=template&id=4f74ac82&scoped=true"
import script from "./MinhasApolices.vue?vue&type=script&lang=js"
export * from "./MinhasApolices.vue?vue&type=script&lang=js"
import style0 from "./MinhasApolices.vue?vue&type=style&index=0&id=4f74ac82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74ac82",
  null
  
)

export default component.exports